import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";

export default function FaqAccordion({ faqs, columns = false }) {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <div className={`w-full ${columns ? "" : "max-w-3xl"}`} data-testid="faq-accordion">
      {faqs.map((f, i) => {
        const isOpen = openIdx === i;
        return (
          <div key={i} className="border-b border-gray-200">
            <button
              onClick={() => setOpenIdx(isOpen ? -1 : i)}
              className="w-full flex items-start justify-between gap-6 py-6 text-left group"
              data-testid={`faq-trigger-${i}`}
              aria-expanded={isOpen}
            >
              <span className={`font-display text-lg lg:text-xl font-bold tracking-tight transition-colors ${isOpen ? "text-[#0B63F6]" : "text-[#111111] group-hover:text-[#0B63F6]"}`}>
                {f.q}
              </span>
              <span className={`shrink-0 mt-1 transition-transform duration-300 ${isOpen ? "rotate-45 text-[#0B63F6]" : "text-gray-400"}`}>
                <Plus className="h-5 w-5" />
              </span>
            </button>
            <AnimatePresence initial={false}>
              {isOpen && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                  className="overflow-hidden"
                >
                  <p className="pb-6 pr-10 text-[15px] leading-relaxed text-gray-600">{f.a}</p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );
}
